var _token = "";

if ($.jStorage.get("localToken")) {
    $("#login_to_reply").hide();
    $("#article_reply_textarea").removeAttr("disabled");
    _token = $.jStorage.get("localToken");
    var avatarUrl = $.jStorage.get("tempAvatar");
    var userName = $.jStorage.get("localName");
    $("#reply-bottom-avatar img").attr('src', avatarUrl);
    $("#reply-bottom-avatar span").text(userName);
    $(".article_reply_btn").removeClass('no-login');
    $("#reply-bottom-avatar").show();
} else {
    $("#login_to_reply").click(function () {
        showLoginPage();
    });
}

//未登录判断点赞是否可点
articleLikedClickable();

//登录状态下，判断点赞按钮，收藏按钮的状态
eventBtnStatus(_token, _article_id, function (data) {
    showLikedAndFavStatus(data);
});

//显示联系TA按钮的状态
// contactBtnStatus();

shortRcomItemTitle();
//侧边栏的title长短控制在23个字以内，多余部分用...代替
function shortRcomItemTitle() {
    if (document.body.clientWidth > 767 && document.body.clientWidth < 992) {
        var itemsArr = $(".recom_items_title");
        for (i = 0; i < itemsArr.length; i++) {
            if (itemsArr[i].innerHTML.length >= 25) {
                itemsArr[i].innerHTML = itemsArr[i].innerHTML.substring(0, 24) + "...";
            }
        }
    }

}


//function sidebarMove(){
//    var topPosition = document.body.scrollTop - 50;
//    var objBorderTop = document.getElementById("hot_articles_container").offsetTop;
//    if(topPosition > objBorderTop){
//        $("#hot_articles_container").addClass("sidebar_move_fixed");
//    }
//}

//点击发表评论按钮，添加评论
$("#add_comment_btn").click(function () {
    if ($.jStorage.get("localToken")) {
        //        showLoadingGif();
        replyArticle();
    } else {
        showWarning("登录后才能回复哦~");
        showLoginPage();
    }
});

//点击回车键发表评论
$("#article_reply_textarea").keyup(function (e) {
    if (e.keyCode == 13) {
        if ($("#article_reply_textarea").val().length <= 5) {
            showWarning("评论字数最少5个！");
            return;
        } else {
            //            showLoadingGif();
            replyArticle();
        }
    }
});

//读取本地缓存，如果未登录状态下本地有缓存，按钮不可点击,否则可点
function articleLikedClickable() {
    if (_token == "") {
        if ($.jStorage.get("liked_" + _article_id)) {
            if ($.jStorage.get("liked_" + _article_id) == "liked") {
                $(".article_like_icon").attr("liked", "true");
                $(".article_like_icon").attr("clickable", "false");
            } else {
                $(".article_like_icon").attr("clickable", "true");
            }
        } else {
            $(".article_like_icon").attr("clickable", "true");
        }
    }
}

//文章点赞
$(".article_like_icon").click(function () {
    var _this = $(this);
    var clickable = _this.attr("clickable");
    //判断能否点击
    if (clickable == "false") {
        return
    }
    _this.attr("clickable", "false");
    var isLiked = _this.attr("liked");
    var articleId = _article_id;
    var likedCountObj = $("#liked_count");
    var likedCount = likedCountObj.html();


    //对未登录用户，判断本地的缓存，并且只能点击一次
    if (_token == "") {
        $.jStorage.set("liked_" + articleId, "liked");
        _this.attr("liked", "true");
        likedCount++;
        likedCountObj.html(likedCount);
        //        showLoadingGif();
        addLikedArticle("", articleId, function () {
            _this.attr("clickable", "false");
        });
        return;
    }


    //对于已登录用户，每2s可以点一次
    likedCount++;
    _this.attr("liked", "true");
    likedCountObj.html(likedCount);

    setTimeout(function () {
        addLikedArticle(_token, articleId, function () {
            _this.attr("clickable", "false");
        });
    }, 2000);
});

//收藏文章
$(".article_collection-list .collectoin_icon").click(function () {
    //未登录弹出登录框
    if (_token == "") {
        showLoginPage();
        showWarning("马上登录，将喜欢的文章放入个人中心~");
        return;
    }

    var _this = $(this);
    var clickable = _this.attr("clickable");
    //判断能否点击
    if (clickable == "false") {
        return
    }
    _this.attr("clickable", "false");
    var isFavorited = _this.attr("favorited");
    var articleId = _article_id;
    var favCountObj = $("#favorited_count");
    var favCount = favCountObj.html();

    //对于已登录用户，每2s可以点一次
    favCount++;
    // _this.attr("favorited", "true");
    favCountObj.html(favCount);
    setTimeout(function () {
        if (isFavorited == 'true') {
            removeFavoriteArticle(_token, articleId, function () {
                _this.attr("clickable", "true");
                _this.attr("favorited", "false");
                $(".article_collection-list .collectoin_icon").removeClass('active');
            });
        } else {
            addFavoriteArticle(_token, articleId, function () {
                _this.attr("clickable", "true");
                _this.attr("favorited", "true");
                $(".article_collection-list .collectoin_icon").addClass('active');
            });
        }
    }, 700);
});

// 微博分享
var weiboUrl = location.href;
var weiboTitle = _article_title ? _article_title : '铅笔道－影响3000万创新公司';
var weiboHref = 'http://service.weibo.com/share/share.php?url=' + weiboUrl + '&title=' + weiboTitle;
$('.article_share-list .webo_share').attr('href', weiboHref);

// 微信/朋友圈分享
$('#qr-div').qrcode({
    text: window.location.href
});

$(".article_share-list .friends_icon,.article_share-list .wechat_icon").mouseenter(function () {
    $("#qr-div").show();
}).mouseleave(function () {
    $("#qr-div").hide();
})

function replyArticle() {
    var content = "";
    content = $("#article_reply_textarea").val();
    if (content == "" || content.length < 5) {
        showWarning("评论字数不能少于5个！");
        return;
    } else {
        showLoadingGif();
        sendAddCommentRequest($.jStorage.get("localToken"), _article_id, "", content, function (_article_id) {
            showLoadingGif();
            getComments(_article_id, "", "", "", _token, function (data) {
                $("#article_reply_textarea").val("");
                $("#article_reply_content").empty();
                showComments(data);
            });
        });
    }
}


function getComments(article_id, page_size, time_start, page, token, fun) {
    $.get({
        url: v1url + "articles/comments",
        headers: {
            token: token,
            devicetoken: cookie_PENCILNEWSID
        },
        data: {
            article_id: article_id,
            page_size: page_size,
            time_start: time_start,
            page: page
        },
        success: function (data) {
            closeLoadingGif();
            fun(data);
        }
    });
}


//展示评论
function showComments(data) {
    var comments = data.data.comments;
    var commentsHTML = "";
    if (!comments || comments.length == 0) {
        commentsHTML = "目前还没有评论，快来抢个沙发吧~";
        $("#reply_comments_info").html(commentsHTML);
        $("#reply_comments_info").addClass("no_reply_container");
        return;
    }
    for (i = 0; i < comments.length; i++) {
        var comment = comments[i];
        var commentId = comment.comment_id;



        var content = comment.content;
        var createAt = comment.create_at;
        var approvalCount = comment.approval_count;
        var approved = comment.approved;
        var approvedHTML = " reply_approved='" + approved + "' ";

        //判断本地缓存，如果有缓存，则按钮不能点击。
        var clickable = "true";
        if ($.jStorage.get("reply_thumb_" + commentId)) {
            if ($.jStorage.get("reply_thumb_" + commentId) == "thumb") {
                if (_token == "") {
                    clickable = "false";
                    approvedHTML = " reply_approved='true' ";
                }
            }
        }

        var userUid = comment.user.uid;
        var userProfile = comment.user.profile;
        var name = userProfile.name;
        var sex = 1;
        var avatarUrl = "";
        if (userProfile.sex) {
            sex = userProfile.sex;
        }
        if (sex == 1) {
            avatarUrl = "/imgs/defaultAva200.png";
        } else {
            avatarUrl = "/imgs/defaultAva200_female.png";
        }
        if (userProfile.avatar) {
            avatarUrl = imgUrl + userProfile.avatar + imageview1x;
        }


        var replyUserHTML = "";
        if (comment.reply_user != null) {
            var replyUserUid = comment.reply_user.uid;
            var replyUserProfile = comment.reply_user.profile;
            var replyUserName = replyUserProfile.name;
            replyUserHTML = '<span>回复</span><span class="reply_user_name">' + replyUserName + '</span>';
        }

        commentsHTML += '<div class="reply_blcok" id="comment_' + commentId + '"><div class="main_reply_blcok"><div class="main_reply_head"><div class="main_reply_avatar"><img src="' + avatarUrl + '"><span class="reply_user_name">' + name + '</span>' + replyUserHTML + '<span>' + createAt + '</span></div></div><div class="main_reply_content"><p>' + content + '</p></div></div><div class="main_reply_info"><div class="main_reply_btn" comment_id="' + commentId + '"><img src="/imgs/icon_reply.png" alt="reply"><span>我要回复</span></div><div clickable="' + clickable + '" class="main_reply_thumb"' + approvedHTML + ' comment_id="' + commentId + '"><span class="icon-agreewith"></span><span id="approved_' + commentId + '">' + approvalCount + '</span></div></div></div>';

    }

    $("#article_reply_content").append(commentsHTML);
    $(".main_reply_btn").click(function (e) {
        if ($.jStorage.get("localToken")) {
            var replyId = $(this).attr("comment_id");
            $(this).parent().hide();
            e.stopPropagation();
            showReplyUserArea($("#comment_" + replyId), replyId);
        } else {
            showWarning("登录后才能回复评论哦~");
            showLoginPage();
        }



    });



    //绑定评论点赞事件
    $(".main_reply_thumb").click(function () {
        var _this = $(this);
        var clickable = _this.attr("clickable");

        //判断能否点击
        if (clickable == "false") {
            return
        }

        _this.attr("clickable", "false");
        var isApproved = _this.attr("reply_approved");
        var commentId = _this.attr("comment_id");
        var appCountObj = $("#approved_" + commentId);
        var appCount = appCountObj.html();


        //对未登录用户，判断本地的缓存，并且只能点击一次
        if (_token == "") {
            $.jStorage.set("reply_thumb_" + commentId, "thumb");
            _this.attr("reply_approved", "true");
            appCount++;
            appCountObj.html(appCount);
            approveComments("", commentId, function () {
                _this.attr("clickable", "false");
            });
            return;
        }


        //对于已登录用户，可以多次点击，每2s可以点一次
        if (isApproved == "true") {
            appCount--;
            _this.attr("reply_approved", "false");
        } else {
            appCount++;
            _this.attr("reply_approved", "true");
        }
        appCountObj.html(appCount);
        setTimeout(function () {
            approveComments(_token, commentId, function () {
                _this.attr("clickable", "true");
            });
        }, 2000);


    });

    if (getUrlParam("comment_id")) {
        location.href = "#comment_" + getUrlParam("comment_id");
        window.history.pushState("", "", location.pathname);
    }

}



function sendAddCommentRequest(token, article_id, comment_id, content, fun) {
    $.post({
        url: v1url + "comments/add",
        headers: {
            token: token,
            devicetoken: cookie_PENCILNEWSID
        },
        data: {
            article_id: article_id,
            comment_id: comment_id,
            content: content
        },
        success: function (data) {
            closeLoadingGif();
            if (data.code == 1000) {
                showSuccess(data.data.msg);
                location.href = "#reply_comments_info";
                fun(article_id);
                var commentsHTML = "所有评论";
                $("#reply_comments_info").removeClass('no_reply_container');
                $("#reply_comments_info").html(commentsHTML);
            } else {
                showWarning(data.message);
            }

        },
        error: function () {}
    });
}


//回复评论
function showReplyUserArea(obj, comment_id) {
    var replyUserEditHTML = '<div id="reply_user_block_' + comment_id + '" class="reply_user_blcok"><div class="reply_user_edit"><textarea reply_user_textarea="' + comment_id + '" placeholder="请在此发表您的看法..."></textarea></div><div class="reply_user_btn"><button class="add_reply_user_comment" reply_comment_id="' + comment_id + '">发表</button></div></div>';
    var replyArea = obj.append(replyUserEditHTML);
    $("textarea[reply_user_textarea=" + comment_id + "]").focus();
    replyArea.click(function (e) {
        e.stopPropagation();
    });

    replyArea[0].addEventListener('touchend', function (e) {
        e.stopPropagation();
    }, false);

    $(".add_reply_user_comment").click(function () {
        var content = $("[reply_user_textarea=" + comment_id + "]").val();
        if (content.length < 5) {
            showWarning("评论字数不能少于5个");
            return;
        }
        var replyUserCommentId = $(this).attr("reply_comment_id");
        showLoadingGif();
        sendAddCommentRequest($.jStorage.get("localToken"), _article_id, replyUserCommentId, content, function (_article_id) {
            getComments(_article_id, "", "", "", _token, function (data) {
                $("#article_reply_textarea").val("");
                $("#article_reply_content").empty();
                showComments(data);
            });
        });
    });

    $("[reply_user_textarea=" + comment_id + "]").keyup(function (e) {
        if (e.keyCode == 13) {
            var content = $("[reply_user_textarea=" + comment_id + "]").val();
            if (content.length <= 5) {
                showWarning("评论字数不能少于5个");
                return;
            }
            var replyUserCommentId = $(this).attr("reply_user_textarea");
            showLoadingGif();
            sendAddCommentRequest($.jStorage.get("localToken"), _article_id, replyUserCommentId, content, function (_article_id) {
                getComments(_article_id, "", "", "", _token, function (data) {
                    $("#article_reply_textarea").val("");
                    $("#article_reply_content").empty();
                    showComments(data);
                });
            });
        }

    });

    $("body").click(function (e) {
        $("#reply_user_block_" + comment_id).remove();
        replyArea.children(".main_reply_info").show();
    });
    document.body.addEventListener('touchend', function (e) {
        $("#reply_user_block_" + comment_id).remove();
        replyArea.children(".main_reply_info").show();
    }, false);


}


//给评论点赞
function approveComments(token, comment_id, fun) {
    $.post({
        url: v1url + "comments/approve",
        headers: {
            token: token,
            devicetoken: cookie_PENCILNEWSID
        },
        data: {
            comment_id: comment_id,
        },
        success: function (data) {
            if (data.code == 1000) {
                fun(data);
            }
        }
    });
}

//给文章点赞
function addLikedArticle(token, article_id, fun) {
    $.post({
        url: v1url + "likes/add",
        headers: {
            token: token,
            devicetoken: cookie_PENCILNEWSID
        },
        data: {
            article_id: article_id,
        },
        success: function (data) {
            closeLoadingGif();
            if (data.code == 1000) {
                fun(data);
            }
        }
    });
}

//收藏文章
function addFavoriteArticle(token, article_id, fun) {
    $.post({
        url: v1url + "favorites/add",
        headers: {
            token: token,
            devicetoken: cookie_PENCILNEWSID
        },
        data: {
            article_id: article_id,
        },
        success: function (data) {
            closeLoadingGif();
            if (data.code == 1000) {
                fun(data);
                showSuccess('收藏成功！')
            } else {
                showWarning(data.message);
            }
        }
    });
}

// 取消收藏文章
function removeFavoriteArticle(token, article_id, fun) {
    $.ajax({
        url:
          v1url +
          "/favorites/remove?" +
          jQuery.param({
            article_id: article_id
          }),
        type: "DELETE",
        headers: {
          token: token,
          devicetoken: cookie_PENCILNEWSID
        },
        success: function (data) {
            closeLoadingGif();
            if (data.code == 1000) {
                fun(data);
                showSuccess('已取消收藏！')
            } else {
                showWarning(data.message);
            }
        }
    });
}

//根据用户是否登录，来判断点赞，收藏的状态
function eventBtnStatus(token, article_id, fun) {
    if (token == "") {
        return;
    } else {
        $.get({
            url: v1url + "user/article",
            headers: {
                token: token,
                devicetoken: cookie_PENCILNEWSID
            },
            data: {
                article_id: article_id
            },
            success: function (data) {
                if (data.code == 1000) {
                    fun(data);
                } else if (data.code == -1) {
                    $.jStorage.flush();
                    $.jStorage.set("localLastUrl", location.href);
                } else {
                    showWarning(data.message);
                }
            },
            error: function () {

            }
        });
    }
}

function showLikedAndFavStatus(data) {
    var liked = data.data.liked;
    var favorited = data.data.userFavorit;
    if (liked) {
        $(".article_like_icon").attr("liked", "true");
        $(".article_like_icon").attr("clickable", "false");
    } else {
        $(".article_like_icon").attr("clickable", "true");
    }
    if (favorited) {
        $(".article_collection-list .collectoin_icon").attr("favorited", "true");
        $(".article_collection-list .collectoin_icon").attr("clickable", "true");
        $(".article_collection-list .collectoin_icon").addClass('active')
    } else {
        $(".article_collection-list .collectoin_icon").attr("clickable", "true");
    }
}

//展示创投认证按钮的状态
function contactBtnStatus() {
    if (_token != "") {
        //...这个接口路由里获取过一遍了。。。
        $.ajax({
            'url': v1url + "articles/detail",
            'type': "GET",
            'data': {
                "article_id": _article_id,
                "sa-super-property": getCookie("sa_obj")
            },
            'headers': {
                "token": _token,
                "devicetoken": cookie_PENCILNEWSID,
            },
            'success': function (data) {
                if (data.code == -1) {
                    return;
                }
                if (data.data.article.articleContacts[0]) {
                    if (data.data.article.articleContacts[0].contacted == 1) {
                        // $("#exchange_contact_btn").html("已同意");
                        $.jStorage.set("agreed-" + _article_id, "agreed");
                    } else if (data.data.article.articleContacts[0].contacted == -1) {
                        $("#exchange_contact_btn").html("已拒绝");
                        $.jStorage.set("refused-" + _article_id, "refused");
                    } else if (data.data.article.articleContacts[0].contacted == 2) {
                        $("#exchange_contact_btn").html("等待对方同意");
                        $.jStorage.set("waitingApproved-" + _article_id, "waiting");
                    } else {
                        $.jStorage.deleteKey("agreed-" + _article_id);
                        $.jStorage.deleteKey("refused-" + _article_id);
                        $.jStorage.deleteKey("waitingApproved-" + _article_id);
                    }
                }
            }

        });
    } else {
        $.jStorage.deleteKey("agreed-" + _article_id);
        $.jStorage.deleteKey("refused-" + _article_id);
        $.jStorage.deleteKey("waitingApproved-" + _article_id);
    }

}

//认证
$("#valid_btn_cancel").click(function () {
    $("#valid_prompt_mask").hide();
    $("body").removeClass("modal-open");
    $("#valid_prompt_container").hide();
});

$("#close_valid_prompt").click(function () {
    $("#valid_prompt_mask").hide();
    $("body").removeClass("modal-open");
    $("#valid_prompt_container").hide();
});

$("#valid_alert_box_cancel,#valid_alert_box_close").click(function () {
    $("#valid_prompt_mask").hide();
    $("body").removeClass("modal-open");
    $("#valid_alert_box").hide();
});

//点击去认证
$("#valid_alert_box_submit").click(function () {
    if (IsPC()) {
        location.href = "/usercenter?cate=my-certification";
    } else {
        location.href = "/m_certification";
    }
});

//点击提交
var valid_btn_clicked = false;
$("#valid_btn_submit").click(function () {
    var contactUid = "";
    var token = $.jStorage.get("localToken");
    var articleId = _article_id;
    if (_contactUid) {
        contactUid = _contactUid;
    }
    //    console.log("contactUid" + contactUid);
    var reason = $("#valid_request_info_text").val();
    //1.验证信息是否填写完整
    if (reason == "") {
        showWarning("理由不能为空，请重新填写！");
        return;
    }
    if (reason.length < 20) {
        showWarning("理由至少20字以上！");
        return;
    }
    if (reason.length > 200) {
        showWarning("理由不能超过200字！");
        return;
    }
    //2.验证token是否过期，过期需要从新登录

    //3.可以提交
    if (valid_btn_clicked) {

        $("#valid_prompt_mask").hide();
        $("body").removeClass("modal-open");
        $("#valid_prompt_container").hide();
        valid_btn_clicked = false;
        return;
    }
    valid_btn_clicked = true;
    showLoadingGif();
    sendContactRequest(v1url, token, articleId, contactUid, reason, function (data) {

        var contactLastTime = data.data.contact_last_times;
        contactLastTime = contactLastTime.replace("\\r\\n", "");
        showSuccess("您的请求信息已发送，请等待TA的反馈。" + contactLastTime);
        //        console.log("修改前的：" + data.data.contact_last_times);
        $("#valid_prompt_mask").hide();
        $("body").removeClass("modal-open");
        $("#valid_prompt_container").hide();
        valid_btn_clicked = false;
        $("#exchange_contact_btn").html("等待对方同意");
        $.jStorage.set("waitingApproved-" + articleId, "waiting");
    });
    //4.提交成功后，弹窗消失，显示成功信息
});

//多选框点击事件


/**************/

/* 联系ta相关function */
//判断是否认证用户
function isValidUser(url, token, fun) {
    url = url + "cert";
    $.get({
        url: url,
        headers: {
            "devicetoken": cookie_PENCILNEWSID,
            token: token
        },
        success: function (data) {
            if ((typeof data) == "string") {
                data = $.parseJSON(data);
            }
            var profile = data.data.user.profile;
            console.log(profile.cert);
            if (profile.cert == null || profile.cert == "") {
                closeLoadingGif();
                $("#valid_prompt_mask").show();
                $("body").addClass("modal-open");
                $("#valid_alert_box").show();
            } else if (profile.cert.state == 1) {
                var contactAvatorUrl = $.jStorage.get("tempImgAvatarUrl");
                if (profile.avatar != null) {
                    contactAvatorUrl = "https://cdn.pencilnews.cn/" + profile.avatar;
                }
                var validLogoUrl = "/imgs/cert_" + profile.cert.cert_type + ".png";
                fun(data);
            } else if (profile.cert.state == 0) {
                closeLoadingGif();
                showWarning("您的认证还在审核中，请等待通过后联系TA");
            } else if (profile.cert.state == -1) {
                closeLoadingGif();
                showWarning("您的认证没有通过，不能联系TA");
            }
        }
    });
}


//
$("#valid_request_info_text").keyup(function () {
    var typedWords = $(this).val();
    $("#typed_word").html(typedWords.length);
    if (typedWords.length < 20 || typedWords.length > 200) {
        $("#typed_word").css("color", "red");
    } else {
        $("#typed_word").css("color", "#999999");
    }
    if (typedWords != "") {
        $(this).attr("placeholder", "");
    } else {
        $(this).attr("placeholder", "来者何人，所为何事？详细说明来意，创业者更容易通过哦～");
    }

});

//发送联系ta请求
function sendContactRequest(url, token, articleId, contactUid, reason, fun) {
    url = url + "contact";
    $.post({
        url: url,
        type: "POST",
        headers: {
            "devicetoken": cookie_PENCILNEWSID,
            token: token
        },
        data: {
            "article_id": articleId,
            "contact_uid": contactUid,
            "reason": reason
        },
        success: function (data) {
            closeLoadingGif();
            console.log("close");
            if ((typeof data) == "string") {
                data = $.parseJSON(data);
            }
            if (data.code != 1000) {
                showWarning(data.message);
            } else {
                fun(data);
            }
        }
    });
}
/*********************/
/*********/


//点击缩小底部联系人横幅
$("#close_contact_btn").click(function () {
    $("#exchange_contact_container").addClass("close_exchange_contact");
});

$("#exchange_contact_border,#exchange_contact_avatar").click(function () {
    $("#exchange_contact_container").removeClass("close_exchange_contact");
});

var clipboard = new Clipboard('#copy_email');
//优雅降级:safari 版本号>=10,提示复制成功;否则提示需在文字选中后，手动选择“拷贝”进行复制
clipboard.on('success', function (e) {
    alert('复制成功!')
    e.clearSelection();
});
clipboard.on('error', function (e) {
    alert('很抱歉，暂时不支持当前浏览器版本，请手动复制')
});

var clipboard2 = new Clipboard('#copy_wechat');
//优雅降级:safari 版本号>=10,提示复制成功;否则提示需在文字选中后，手动选择“拷贝”进行复制
clipboard2.on('success', function (e) {
    alert('复制成功!')
    e.clearSelection();
});
clipboard2.on('error', function (e) {
    alert('很抱歉，暂时不支持当前浏览器版本，请手动复制')
});

//关闭联系方式的弹框
$("#close_contact_board").click(function () {
    $(".contact_board_container").hide();
    $("#valid_prompt_mask").hide();
    $("body").removeClass("modal-open");
});

//判断对方是否开启了验证才能交换联系方式,目前方法为空，布尔值，默认为false，自动同意为true;
function isAutoAgree() {
    if (_auto_accept_contact) {
        if (_auto_accept_contact == 0) {
            //            console.log(0);
            return false;
        }
        if (_auto_accept_contact == 1) {
            //            console.log(1);
            return true;
        }
    } else {
        //        console.log("没这个字段");
        return false;
    }
}

$("#valid_btn_submit").click(function () {
    var contactUid = "";
    var token = $.jStorage.get("localToken");
    var articleId = _article_id;
    if (_contactUid) {
        contactUid = _contactUid;
    }
    //    console.log("contactUid" + contactUid);
    var reason = $("#valid_request_info_text").val();
    //1.验证信息是否填写完整
    if (reason == "") {
        showWarning("理由不能为空，请重新填写！");
        return;
    }
    if (reason.length < 20) {
        showWarning("理由至少20字以上！");
        return;
    }
    if (reason.length > 200) {
        showWarning("理由不能超过200字！");
        return;
    }
    //2.验证token是否过期，过期需要从新登录

    //3.可以提交
    if (valid_btn_clicked) {

        $("#valid_prompt_mask").hide();
        $("body").removeClass("modal-open");
        $("#valid_prompt_container").hide();
        valid_btn_clicked = false;
        return;
    }
    valid_btn_clicked = true;
    showLoadingGif();
    sendContactRequest(v1url, token, articleId, contactUid, reason, function (data) {
        valid_btn_clicked = false;
        //    $(".contact-entrepreneur").unbind("click");
        //    $(".contact-entrepreneur").css("background", "#c2c2c2");
        $("#exchange_contact_btn").html("等待对方同意");
        $.jStorage.set("waitingApproved-" + articleId, "waiting");
    });
    //4.提交成功后，弹窗消失，显示成功信息
});


//点击出现联系ta的弹窗
$("#exchange_contact_btn").click(function () {
    //1.认证是否登录
    if ($.jStorage.get("localToken")) {
        if ($.jStorage.get("waitingApproved-" + _article_id)) {
            if (!IsPC()) {
                window.location = "/m_contactlist?mycontacts=click";
            } else {
                window.location = "/usercenter?cate=my-contact&state=contact-todo";
            }

        }
        // else if ($.jStorage.get("agreed-" + _article_id)) {
        //     if(!IsPC()){
        //         window.location = "/m_contactlist?mycontacts=click";
        //     }else{
        //         window.location = "/usercenter?cate=my-contact&state=contact-agreed";
        //     }
        // }
        else if ($.jStorage.get("refused-" + _article_id)) {
            if (!IsPC()) {
                window.location = "/m_contactlist?mycontacts=click";
            } else {
                window.location = "/usercenter?cate=my-contact&state=contact-refused";
            }

        } else {
            showLoadingGif();
            $.get({
                url: v1url + '/articles/detail?app=web&article_id=' + _article_id,
                headers: {
                    "devicetoken": cookie_PENCILNEWSID,
                    token: _token
                },
                success: function (data) {
                    closeLoadingGif();
                    var contact = data.data.article.articleContacts[0];
                    if (contact.contacted == 1) {
                        // $("#exchange_contact_btn").html("已同意");
                        $.jStorage.set("agreed-" + _article_id, "agreed");
                        var contactProfile = contact.profile;
                        var boardPhone = contactProfile.phone;
                        var boardMail = contactProfile.email;
                        var boardWechat = contactProfile.wechat;
                        $("#board_email").html(boardMail);
                        $("#board_wechat").html(boardWechat);
                        $("#board_phone").html(boardPhone);
                        $("#board_phone_tel").attr("href", "tel:" + boardPhone);
                        $(".contact_board_container").show();
                        $("#valid_prompt_mask").show();
                        $("body").addClass("modal-open");
                        // var contactLastTime = data.data.contact_last_times;
                        // contactLastTime = contactLastTime.replace("\\r\\n","");
                        // showWarning(contactLastTime);
                    } else {
                        isValidUser(v1url, $.jStorage.get("localToken"), function (data) {
                            //判断是否同意交换，默认为不同意
                            if (isAutoAgree()) {
                                var contactUid = "";
                                if (_contactUid) {
                                    contactUid = _contactUid;
                                }

                                sendContactRequest(v1url, $.jStorage.get("localToken"), _article_id, contactUid, "", function (data) {
                                    // $("#exchange_contact_btn").html("已同意");
                                    $.jStorage.set("agreed-" + _article_id, "agreed");
                                    var contactProfile = data.data.contact.user.profile;
                                    var boardPhone = contactProfile.phone;
                                    var boardMail = contactProfile.email;
                                    var boardWechat = contactProfile.wechat;
                                    $("#board_email").html(boardMail);
                                    $("#board_wechat").html(boardWechat);
                                    $("#board_phone").html(boardPhone);
                                    $("#board_phone_tel").attr("href", "tel:" + boardPhone);
                                    $(".contact_board_container").show();
                                    $("#valid_prompt_mask").show();
                                    $("body").addClass("modal-open");
                                    var contactLastTime = data.data.contact_last_times;
                                    contactLastTime = contactLastTime.replace("\\r\\n", "");
                                    showWarning(contactLastTime);
                                });
                            } else {
                                //不同意直接交换联系方式，需要进行验证
                                closeLoadingGif();
                                if (IsPC()) {
                                    $("#valid_prompt_mask").show();
                                    $("body").addClass("modal-open");
                                    $("#valid_prompt_container").show();
                                } else {
                                    var redicHref = "/m_contactta?article_id=" + _article_id + "&contact_uid=" + _contactUid;
                                    //                        console.log(redicHref);
                                    location.href = redicHref;
                                }

                            }

                        });
                    }
                }
            });

        }

    } else {
        showWarning("您只有登录并且认证身份后，才能联系TA哦");
        $.jStorage.set("isJumpApprove", "on");
        if (IsPC()) {
            showPCLoginForm();
        } else {
            var ucValidUrl = "/m_certification";
            $.jStorage.set("localLastUrl", ucValidUrl);
            $.jStorage.set("localPhoneArticle", location.href);
            $.jStorage.set("isJumpApprove", "off");
            setTimeout(function () {
                window.location = "/login_phone";
            }, 1000);
        }

    }

});

;
(function (global, undefined) {
    $('.proj-wrap').eq(0).on('click', function () {
        var projectId = $(this).data('projectId');
        var newTab = window.open('about:blank');
        newTab.location.href = '/projectdetail/' + projectId + "?from=article_project";
    });

    var userRoleId = $.jStorage.get("localRoleId");
    if (userRoleId && userRoleId >= 6) {
        $('#downloadImage').show();
    }
    // 生成小程序分享图片
    $('#downloadImage').on('click', function () {
        var $pngDom = $('.proj-table-small .proj-wrap').get(0);
        $('.proj-table-small').show();
        domtoimage.toJpeg($pngDom, {
                quality: 1
            })
            .then(function (dataUrl) {
                var link = document.createElement('a');
                link.download = 'my-image-name.jpeg';
                link.href = dataUrl;
                link.click();
                $('.proj-table-small').hide();
            });
    });

})(this);